import React, {Component} from 'react';
import {Modal} from 'reactstrap';

class Popup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: this.props.open ? false : this.props.open
    };
  }

  render() {
    return (
      <>
        <Modal isOpen={this.props.open} togglepopup={this.props.toggle}
          className={['modal-general', this.props.className].join(' ')} centered>
          <div className="popup-join-inner">
            {this.props.text.split('\n').map((item, ix) => {
              return <p key={ix}>{item}</p>
            })}
            <div className="popup-btn-wrapper">
              <button className="btn btn-none" onClick={this.props.toggle}>Close</button>
              {this.props.okfunc &&
                <button className="btn popup-other-btn" onClick={this.props.okfunc}>OK</button>
              }
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

export default Popup;